export default __webpack_public_path__ + "static/media/aboutUsImage.298a3aea.png";